import { Suspense, useEffect } from 'react';
import { RouterProvider } from 'react-router-dom';
import './App.scss';

import theme from './theme';
import { Provider } from 'jotai';
import { store } from './services/atom.service';
import { preloadRoutes, router } from './router';

import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import ThemeProvider from '@mui/material/styles/ThemeProvider';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Loading } from './components/Loading';

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 5 * 60 * 1000,  // 5 minutes
            gcTime: 10 * 60 * 1000,    // 10 minutes
        },
    },
});

export default function App() {
    // Fetch the other pages' code in the background so navigating never waits for a download
    useEffect(() => preloadRoutes(), []);

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <ThemeProvider theme={theme}>
                <QueryClientProvider client={queryClient}>
                    <Provider store={store}>
                        <Suspense fallback={<Loading />}>
                            <RouterProvider router={router} />
                        </Suspense>
                    </Provider>
                </QueryClientProvider>
            </ThemeProvider>
        </LocalizationProvider>
    );
}
